export enum MediaDomainEvents {
    enumerateDevicesNotSupported = 'enumerate_devices_not_supported',
    checkingMediaPermissions = 'checking_media_permissions',
    checkedMediaPermissions = 'checked_media_permissions',
    permissionsModalOpened = 'permissions_modal_opened',
    permissionsRequested = 'permissions_requested',
    permissionsModalClosed = 'permissions_modal_closed',
    alreadyAcceptedMediaPermissions = 'already_accepted_media_permissions',
    acceptedMediaPermissions = 'accepted_media_permissions',
    notAcceptedMediaPermissions = 'not_accepted_media_permissions',
    deniedMediaPermissions = 'denied_media_permissions',
    blockedMediaPermissions = 'blocked_media_permissions',
    noCameraDevice = 'no_camera_device',
    noMicDevice = 'no_mic_device',
    noAudioDevice = 'no_audio_device',
    cannotListMediaDevices = 'cannot_list_media_devices',
    emptyListMediaDevices = 'empty_list_media_devices',
    cannotListAudioInputDevices = 'cannot_list_audio_input_devices',
    cannotListAudioOutputDevices = 'cannot_list_audio_output_devices',
    cannotListVideoInputDevices = 'cannot_list_video_input_devices',
    changeMicDevice = 'change_mic_device',
    changeCamDevice = 'change_cam_device',
    changeAudioOutputDevice = 'change_audio_output_device',
    cannotChangeMicDevice = 'cannot_change_mic_device',
    cannotChangeCamDevice = 'cannot_change_cam_device',
    cannotChangeAudioOutputDevice = 'cannot_change_audio_output_device',
    changedMicDevice = 'changed_mic_device',
    changedCamDevice = 'changed_cam_device',
    changedAudioOutputDevice = 'changed_audio_output_device'
} 